/**
 * Analysis API Service
 */
import apiClient from './client';
import type { UploadResponse, JobStatus, AnalysisResult, ComparisonData } from '../../types';

export const uploadDocument = async (files: File | File[], userGuidance: string | null = null, forceReanalyze: boolean = false): Promise<UploadResponse> => {
  const formData = new FormData();
  const fileArray = Array.isArray(files) ? files : [files];
  
  fileArray.forEach((file) => {
    formData.append('files', file);
  });
  
  if (userGuidance) {
    formData.append('user_guidance', userGuidance);
  }
  
  if (forceReanalyze) {
    formData.append('force_reanalyze', 'true');
  }

  const response = await apiClient.post('/api/analyze', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

export const checkAnalysisStatus = async (jobId: string): Promise<JobStatus> => {
  const response = await apiClient.get(`/api/analysis/status/${jobId}`);
  return response.data;
};

export const getAnalysisResult = async (jobId: string): Promise<AnalysisResult> => {
  const response = await apiClient.get(`/api/analysis/result/${jobId}`);
  return response.data;
};

export const getUserAnalyses = async (): Promise<{ analyses: any[] }> => {
  const response = await apiClient.get('/api/analyses');
  return response.data;
};

export const deleteAnalysis = async (analysisId: string): Promise<{ success: boolean }> => {
  const response = await apiClient.delete(`/api/analyses/${analysisId}`);
  return response.data;
};

export const loadTestAnalysis = async (): Promise<{ result: AnalysisResult; job_id: string }> => {
  const response = await apiClient.get('/api/test-analysis');
  return response.data;
};

export const compareAnalyses = async (id1: string, id2: string): Promise<ComparisonData> => {
  const response = await apiClient.get(`/api/analyses/compare?id1=${id1}&id2=${id2}`);
  return response.data;
};

export const getAnalysisCompleteness = async (analysisId: string): Promise<any> => {
  const response = await apiClient.get(`/api/analysis/${analysisId}/completeness`);
  return response.data;
};

export const extendAnalysis = async (analysisId: string, files: File | File[], userGuidance: string | null = null): Promise<{ job_id: string; status: string; message: string }> => {
  const formData = new FormData();
  const fileArray = Array.isArray(files) ? files : [files];
  
  fileArray.forEach((file) => {
    formData.append('files', file);
  });
  
  if (userGuidance) {
    formData.append('user_guidance', userGuidance);
  }

  const response = await apiClient.post(`/api/analysis/extend/${analysisId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};
